import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Subscription, forkJoin, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { SchemeService } from '../../services/scheme.service';
import { PermissionsService } from '../../services/permission.service';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../environments/environment';
import { init } from '../editorconfig';
import { UploadService } from '../../services/upload/upload.service';
import { IdexFromComponent } from './idex-from/idex-from.component';
import { OcProposalUploadComponent } from './oc-proposal-upload/oc-proposal-upload.component';

@Component({
  selector: 'app-idex-scheme-list',
  standalone: false,
  templateUrl: './idex-scheme-list.component.html',
  styleUrl: './idex-scheme-list.component.scss',
})
export class IdexSchemeListComponent implements OnInit {
  schemes = [];
  viewDetails: boolean = false;
  viewProposals: boolean = false;
  addProposalVisible: boolean = false;
  selectedScheme: any;
  selectedPhase: any;
  phases = [];
  items = [
    { label: 'Add Challenge', command: () => this.activeIndex = 0 },
    { label: 'Route Configuration', command: () => { this.apiCallForTransaction(); this.activeIndex = 1; } }
  ];
  private subscriptions = new Subscription();
  itemsPerPage: number = 9;
  currentPage: number = 1;
  activeTabIndex: number = 0;
  proposalData = [];
  filteredRecentProposals: any[];
  activeIndex: number = 0;
  proposalForm: FormGroup;
  routeForm: FormGroup;
  roleList = []
  userList = []
  unitList = []
  filteredStagesList: any[] = []
  roleID: number | null = null;
  userID: any;
  isUpdateProposal: boolean = false;
  currentSchemeId: any;
  currentsubSchemeId: any;
  selectedProposal: any;
  activePhaseId: any;
  stages: any;
  currentUserRoleId: string;
  completionSum: any;
  RouteUserList: any[] = [];
  userCols: any[] = [
    { field: 'user.first_name', header: 'First Name', filterType: 'text' },
    { field: 'user.last_name', header: 'Last Name', filterType: 'text' },
    {
      field: 'proposal_step.name',
      header: 'Proposal Step Name',
      filterType: 'text',
    },
    { field: 'role.name', header: 'Role', filterType: 'text' },
  ];
  isDeleteProposal: boolean = false;
  stepId: number | null = null;
  selectedPhaseId: any;
  activeTabName: any;
  addMode: string;
  currentPhaseName: any;
  transactionPhaseStages: any;
  searchProposalQuery: any;
  stagesList: any;
  userListCopy: any[];
  // New design
  activeTab: any = 'initiation';
  proposals: Proposal[] = [];
  filteredProposals: Proposal[] = [];
  currentRole: string = 'doi';
  selectAll: boolean = false;

  stats = { total: 0, pending: 0, screening: 0, approved: 0 };

  filters = { category: '', status: '', priority: '', valuation: '' };
draftProposalColumns: any[] = [
      { field: 'nomenclature', header: 'Name', filterType: 'text' },
    { field: 'modified_on', header: 'Last Update', filterType: 'text' },
  ]
  // Modal control
  detailsModalOpen = false;
  challengeForm: FormGroup;
  categoryOptions = [
    { label: 'To Move', value: 'To Move' },
    { label: 'To Fight', value: 'To Fight' },
    { label: 'To Float', value: 'To Float' },
  ];
  priorityOptions = [
    { label: 'High', value: 'High' },
    { label: 'Medium', value: 'Medium' },
    { label: 'Low', value: 'Low' },
  ];
  statusOptions = [
    { label: 'Launch', value: 'Launch' },
    { label: 'Duplicate', value: 'Duplicate' },
    { label: 'Reject', value: 'Reject' },
  ];
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  draftSotr: File;
  draftSotrFile: File | null = null;
  supportingDocsFiles: File | null = null;
  @ViewChild('draftSotrUpload') draftSotrUpload!: FileUpload;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  PDSGenId: any;
  screening: any;
  apiUrl = environment.APIUrl;
  needGenData: any;
  needGenId;
  @Input() isEditable: boolean = false;
  selectedChallenges: Proposal[];
  isEditMode = false;
  currentAction: 'view' | 'edit' = 'view';
  IRAremarks: string;
  selectedChallengeCount: any[];
  schemeID: any;
  needId!: number; // ✅ add this line
  selectedSchemeName: string | null = null;
  lazy: boolean = true;
  uploadedDocuments: any[] = [];
  selectedProposals: any[] = [];
  equipment: Equipment[] = [];
  system: System[] = [];
  filteredEquipment: Equipment[] = [];
  filteredSystem: System[] = [];
  // Proposal status tabs
  otherSchemeStatusTabs = [
    { label: 'New Proposal', status: 'form', active: true, tab: 0 }, // Special status for form
    { label: 'Pre Launch', status: 'initiated', active: false, tab: 1 }, // Show initiated proposals
    { label: 'For Launch(Proposal Banked)', status: 'project_bank', active: false, tab: 1 },
    { label: 'Post Launch', status: 'in_review', active: false, tab: 1 }, // Show initiated proposals
    { label: 'Completed Proposal', status: 'approved', active: false, tab: 1 },
    { label: 'Short Closed Proposal', status: 'short_close', active: false, tab: 1 },
    { label: 'Rejected Proposal', status: 'rejected', active: false, tab: 1 },
  ];
  proposalStatusTabs=[...this.otherSchemeStatusTabs]
  proposalTableHeader = [
    { field: 'checkbox', header: '', filterType: 'text', filter: false },
    { field: 'directorate', header: 'Directorate', filterType: 'text', filter: true },
    { field: 'name', header: 'Name', filterType: 'text', filter: true },
    // { field: 'description', header: 'Description', filterType: 'text', filter: true },
    { field: 'steps', header: 'Current Step', filterType: 'text' },
    { field: 'steps', header: 'Steps', filterType: 'text' },
    { field: 'progress', header: 'Progress', filterType: 'text', filter: true },
    { field: 'proposal_status', header: 'Status', filterType: 'text', filter: true }
  ];
  tableColumns: any[] = [];
  tenderModes = [
    { label: 'Open Tender', value: 'Open Tender' },
    { label: 'Single Tender', value: 'Single Tender' },
    { label: 'Limited Tender', value: 'Limited Tender' },
  ];
  allDmsFiles: any[] = [];
  proposal_step_id: any;
  // activeStatusTabIndex = 0;
  activeStatusTabIndex: any = this.proposalStatusTabs[0];
  selectedDraftProposal: any = null;
  selectedDmsFiles: any[] = [];
  @ViewChild(IdexFromComponent) idexFromComponent!: IdexFromComponent;
  @ViewChild(OcProposalUploadComponent) ocProposalUploadComponent!: OcProposalUploadComponent;
  constructor(
    private apiService: ApiService,
    private router: Router,
    private fb: FormBuilder,
    private messageService: MessageService,
    private uploadService: UploadService,
    private route: ActivatedRoute,
    private schemeService: SchemeService,
    private permissionService: PermissionsService
  ) {
    this.routeForm = this.fb.group({
      step: ['', Validators.required],
      role: ['', Validators.required],
      user: ['', Validators.required],
      unit: ['', Validators.required],
      level: ['', Validators.required],
      approved: [false, Validators.required],
    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    

    this.getUserList();
    this.getUnit();
    this.route.queryParams.subscribe((params: any) => {
      const scheme_id = params['scheme_id'];
      this.currentSchemeId = scheme_id
    });
    this.initializeNewProposalForm();
    this.getDraftProposals()
    this.getSchemes();

    this.routeForm = this.fb.group({
      step: ['', Validators.required],
      role: [''],
      user: [''],
      unit: [''],
      level: [{ value: '', disabled: true }],
      approved: [false]
    })
    this.switchRole('doi');
    this.challengeForm = this.fb.group({
      organisation: ['', Validators.required],
      category: [''],
      priority: [''],
      challenge_status: [''],
      ip_status: [''],
      releaseDate: ['', Validators.required],
      approvedBy: [''],
      coordinatingAgency: ['', Validators.required],
      technologyDomain: ['', Validators.required],
      challengeTitle: ['', Validators.required],
      nodalOfficer: ['', Validators.required],
      problemStatement: ['', Validators.required],
      challengeBrief: ['', Validators.required],
      prototypeDevelopment: ['', Validators.required],
      requirement: ['', Validators.required],
      ipValue: [''],
      functionalAdvantages: ['', Validators.required],
      domestic: ['', Validators.required],
      substitution: ['', Validators.required],
      preliminaryScope: ['', Validators.required],
      competitiveSolution: ['', Validators.required],
      potentialMarket: ['', Validators.required],
      riskAssessment: ['', Validators.required],
      mpoQty: ['', Validators.required],
    });
    this.route.queryParams.subscribe(params => {
      const schemeId = params['scheme_id'];
      this.schemeID = schemeId
    });
    if (this.activeTab == 'initiation') {
      this.gettableData();
    }
  }
  // ✅ Initialize form
  initializeNewProposalForm() {
    this.proposalForm = this.fb.group({
      id: [null],                      // challenge_id
      proposal_id: [null],             // proposal_id
      name: ['', Validators.required], // proposal_name / title
      scheme_name: [null, Validators.required], // scheme_id
      coordinated_agency: ['', Validators.required], // coordinated_agency
      nodal_officer: ['', Validators.required],       // nodal_officer
      organisation: ['', Validators.required],
      category: ['', Validators.required],
      release_date: ['', Validators.required],
      technology_domain: ['', Validators.required],
      problem_statement: ['', Validators.required],
      challenge_brief: [''], // challenge_brief
      prototype_development: [''],   // prototype_development
      description: [''],
      status: [1],
    });
    // Reset draft-related variables when initializing new form
    this.selectedDraftProposal = null;
    this.selectedDmsFiles = [];
  }
  onTabChange(event: any): void {
    console.log(event)
    this.activeTabIndex = event.index;
    this.currentPage = 1; // ✅ Reset to page 1 on tab switch
    this.activePhaseId = this.phases[event.index]?.id;
    this.selectedPhaseId = this.phases[event.index]?.id;
    this.getProposal()
  }
  // onPageChange(event: any) {
  //   this.currentPage = event.page + 1;
  // }
  getSchemes() {
    let url = this.currentSchemeId ? `/master/scheme/sub/details/?id=${this.currentSchemeId}` : `/master/scheme/sub/details/`
    const sub = this.apiService
      .getAPI(url)
      .subscribe((res: any) => {
        this.schemes = res[0].sub_scheme
        console.log('>>>>>sdsmdskm', this.schemes);

      });
    this.subscriptions.add(sub);
  }
  // For OC, pre launch tab to be renamed as "Shortlisted Proposals", For Launch as "APSO approved" and post launch as "VCNS approved/ongoing proposals".
  selectScheme(scheme: any) {
    if (scheme.id !== 7) {
      this.proposalStatusTabs=[...this.otherSchemeStatusTabs]
    }
    if(scheme.id == 7) {
      this.proposalStatusTabs=[
        { label: 'New Proposal', status: 'form', active: true, tab: 0 }, // Special status for form
        { label: 'OC Version', status: 'oc_version', active: false, tab: 2 }, // Show initiated proposals
        { label: 'Shortlisted Proposals', status: 'initiated', active: false, tab: 1 }, // Show initiated proposals
        { label: 'APSO approved', status: 'project_bank', active: false, tab: 1 }, // Show initiated proposals
        { label: 'VCNS approved/ongoing proposals', status: 'in_review', active: false, tab: 1 }, // Show initiated proposals
        { label: 'Completed Proposal', status: 'approved', active: false, tab: 1 },
        { label: 'Short Closed Proposal', status: 'short_close', active: false, tab: 1 },
        { label: 'Rejected Proposal', status: 'rejected', active: false, tab: 1 },
      ]
      
    }
    
    this.selectedSchemeName = scheme.name.toUpperCase() + ' SCHEME';
    this.getSchemewisePhase(scheme.id);
    this.viewDetails = true;
    this.selectedScheme = scheme;
    // ✅ Patch form value for dropdown and disable
    if (this.proposalForm) {
      this.proposalForm.get('scheme_name')?.patchValue(scheme.id);
      // this.proposalForm.get('scheme')?.disable(); // make it readonly
    }
  }

  viewProposal(scheme: any, phase: any) {
    this.viewProposals = true;
    this.selectedPhase = phase;
  }
  getProposal(tab:any='',page=1) {
    this.proposalData=[]
    // this.lazy=true;
    let url=`/master/proposals/?scheme=${this.currentsubSchemeId}&page=${page}`;
    if(tab){
      url+=`&proposal_status=${tab.status}`;
    }
    const sub = this.apiService.getAPI(url ).subscribe((res: any) => {
        this.proposalData = res.results;
        this.filteredRecentProposals = [...this.proposalData];
        this.totalCount = res.count;
        // this.filterProposalsByStatus(); // Apply initial filtering based on active tab
      });
    this.subscriptions.add(sub);
  }
  getPagedProposals(): any[] {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    return this.proposalData.slice(start, end);
  }
  addProposal(mode: 'new' | 'existing' = 'new') {
    // this.transactionPhaseStages = [];
    this.addMode = mode;
    this.activeTabName = this.phases[this.activeTabIndex]?.name || '';
    this.proposalForm.reset();
    this.routeForm.reset();
    this.getSchemes();
    // this.proposalForm.get('scheme')?.disable();
    this.proposalForm.get('scheme')?.patchValue(this.currentsubSchemeId);
    this.activeIndex = 0;
    this.addProposalVisible = true;
    this.isUpdateProposal = false;
    // Reset draft-related variables when adding new proposal
    this.selectedDraftProposal = null;
    this.selectedDmsFiles = [];
    // this.currentPhaseName = '';

  }
  // onSubmit() {
  //   const data = {
  //     name: this.proposalForm.get('proposalName')?.value,
  //     description: this.proposalForm.get('description')?.value,
  //     scheme: this.proposalForm.get('scheme')?.value,
  //     phase: this.activePhaseId,
  //     status: 1,
  //   };
  //   if (this.isUpdateProposal) {
  //     const sub = this.apiService
  //       .putAPI(`/master/proposals/${this.selectedProposal.id}/`, data)
  //       .subscribe((res: any) => {
  //         this.selectedProposal = res;
  //         this.messageService.add({
  //           severity: 'success',
  //           summary: 'Success',
  //           detail: res.message || 'Proposal Updated Successfully',
  //         });
  //         this.apiCallForTransaction()
  //         // this.confirmSkipStage()
  //         this.getStages(this.proposalForm.get('scheme')?.value, 'pass');
  //         this.getProposal();
  //         this.activeIndex = 1;
  //       });
  //     this.subscriptions.add(sub);
  //   } else {
  //     const sub = this.apiService
  //       .postAPI('/master/proposals/', data)
  //       .subscribe((res: any) => {
  //         this.selectedProposal = res;
  //         this.messageService.add({
  //           severity: 'success',
  //           summary: 'Success',
  //           detail: res.message || 'Proposal Added Successfully',
  //         });
  //         // this.confirmSkipStage()
  //         this.getStages(this.proposalForm.get('scheme')?.value, 'no');
  //         this.getProposal();
  //         if (this.addMode === 'existing') {
  //           this.insertIntermediateSteps(
  //             this.proposalForm.get('scheme')?.value,
  //             this.activePhaseId
  //           );
  //           this.activeIndex = 1;
  //           this.currentPhaseName = this.activeTabName;
  //           this.fetchAndSubmitProposalSteps(
  //             this.proposalForm.get('scheme')?.value,
  //             this.proposalForm.get('scheme')?.value?.name,
  //             this.selectedProposal.id,
  //             this.activePhaseId
  //           );
  //         } else {
  //           this.activeIndex = 1; // go to next step directly
  //           this.apiCallForTransaction()
  //           // this.setActiveIndex(this.activeIndex)
  //         }
  //       });
  //     this.subscriptions.add(sub);
  //   }

  //   this.onNeedformSubmit();
  // }
  insertIntermediateSteps(scheme: any, phaseId: any) {
    const currentPhase = this.phases?.find((p) => p.id === phaseId);
    const phaseName = currentPhase?.name;

    this.currentPhaseName = phaseName;

    const firstStep = { label: 'Add Proposal' };
    const mandatoryStep = { label: 'Mandatory steps from Previous Phases' };
    const lastSteps = [
      { label: 'Skip Stages' },
      { label: 'Route Configuration' },
    ];

    const newSteps = [];

    if (
      phaseName === 'Prototype Development' ||
      phaseName === 'Mass Production'
    ) {
      newSteps.push(mandatoryStep);
    }

    this.items = [firstStep, ...newSteps, ...lastSteps];
  }
  fetchAndSubmitProposalSteps(
    schemeId: number,
    scheme_Name: string,
    proposalId: number,
    phaseId: number
  ): void {
    let optionalStepCodes: string[] = [];
    const scheme = this.schemes.find((s) => s.id === schemeId);
    if (!scheme) {
      console.error('Scheme not found for ID:', schemeId);
      return;
    }

    const schemeName = scheme.name;
    optionalStepCodes = [
      'R-ND',
      'R-AIP',
      'R-NOQA',
      'R-VI',
      'R-RFP-SOC',
      'R-AoN',
      'R-PRFPM',
      'R-FS',
      'R-PBC',
      'R-TEC',
      'R-BM',
      'R-FO',
      'R-PSO',
      'Rev_011',
      'Rev_012',
      'idex_007',
      'Rev_017',
      'Rev_013',
      'Rev_014',
    ];

    const index = this.phases.findIndex(
      (p) => p.name === this.currentPhaseName
    );

    if (index > 0) {
      for (let i = 0; i < index; i++) {
        const phase = this.phases[i];

        const sub = this.apiService
          .getAPI(
            `/master/scheme-step/mapping/?scheme=${schemeId}&phase_id=${phase.id}`
          )
          .subscribe(
            (res: any) => {
              const stagePayload = res.map((item: any) => {
                const skipped = !optionalStepCodes.includes(item.step.code);

                return {
                  step_mapping: item.id,
                  name: item.step.name,
                  sequence: item.sequence,
                  skipped,
                  code: item.step.code,
                  remark: '',
                  isSelected: false,
                  ...(skipped === false && { make_initiator: true }), // ✅ Conditionally add the key
                };
              });

              this.transactionPhaseStages.push({
                phase: phase,
                stages: stagePayload,
              });

              this.apiService
                .postAPI(
                  `/transaction/proposals/${proposalId}/steps/`,
                  stagePayload
                )
                .subscribe(
                  (submitRes: any) => { },
                  (submitErr) => { }
                );
            },
            (err) => { }
          );
        this.subscriptions.add(sub);
      }
    }
  }
  deleteProposal(proposal?: any) {
    this.isDeleteProposal = true;
    this.selectedProposal = proposal;
  }
  confirmDelete() {
    if (this.isDeleteProposal) {
      let schemeId = this.selectedProposal.id;
      const sub = this.apiService
        .deleteAPI(`/master/proposals/${schemeId}/`)
        .subscribe((res: any) => {
          // if (res) {
          this.isDeleteProposal = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Proposal Deleted Successfully',
          });
          // }
          this.getProposal();
        });
      this.subscriptions.add(sub);
    }
  }
  searchProposals(event: any) {
    this.searchProposalQuery = event.target.value.toLowerCase();
    this.proposalData = this.filteredRecentProposals.filter(
      (proposal) =>
        proposal.name.toLowerCase().includes(this.searchProposalQuery) ||
        proposal.description.toLowerCase().includes(this.searchProposalQuery) ||
        proposal.scheme.name?.toLowerCase().includes(this.searchProposalQuery)
    );
    this.currentPage = 1; // Reset to first page when searching
  }
  updateProposal(proposal: any) {
    this.selectedProposal = proposal;  // Store selected proposal
    this.isUpdateProposal = true;
    this.addProposalVisible = true;
    this.activeIndex = 0;
    this.proposalForm.patchValue({
      proposalName: proposal.name,
      scheme: proposal.scheme.id,
      // fund: proposal.fund,
      description: proposal.description
    });
    // Make sure the scheme dropdown correctly displays the name
    this.populateScheme(proposal.scheme);
    this.getSchemes();
    // this.getFunds();
    this.getStages(this.proposalForm.get('scheme')?.value, 'pass');
    // Important: Disable scheme control manually
    this.proposalForm.get('scheme')?.disable();
  }
  populateScheme(schemeId: number) {
    const selectedScheme = this.schemes.find(s => s.id === schemeId);
    if (selectedScheme) {
      this.proposalForm.patchValue({ scheme: selectedScheme.id });
    }
  }
  getStages(schemeId: any, pass: any) {
    if (this.isUpdateProposal && pass == 'pass') {
      const sub = this.apiService.getAPI(`/transaction/proposals/${this.selectedProposal.id}/steps/?phase_id=${this.activePhaseId}`).subscribe((res: any) => {
        this.stages = res.map((item: any) => ({
          // master_step: item.master_step,
          step_mapping: item.step_mapping,
          name: item.name,
          sequence: item.sequence,
          skipped: item.skipped,
          code: item.code,
          remark: item.remark,
          isSelected: item.isSelected,
          week_timeline: item.week_timeline,
          percentage: item.percentage
        }));
        this.calculateCompletionSum()
        if (res.length < 1) {
          this.apiService.getAPI(`/master/scheme-step/mapping/?scheme=${schemeId}`)
            .subscribe((res: any) => {
              this.stages = res.map((item: any) => ({
                // master_step: item.step.id,
                step_mapping: item?.id,
                name: item.step.name,
                sequence: item.sequence,
                skipped: item.step.code == 'R-POC' ? true : false,
                code: item.step.code,
                week_timeline: item.week_timeline,
                percentage: item.percentage,
                remark: '',
                isSelected: false
              }));
              this.calculateCompletionSum()
              this.confirmSkipStage()
            });
        }
      });
      this.subscriptions.add(sub);
    } else {
      const sub = this.apiService.getAPI(`/master/scheme-step/mapping/?scheme=${schemeId}`).subscribe((res: any) => {
        this.stages = res.map((item: any) => ({
          // master_step: item.step.id,
          step_mapping: item.id,
          name: item.step.name,
          sequence: item.sequence,
          skipped: item.step.code == 'R-POC' ? true : false,
          code: item.step.code,
          remark: '',
          week_timeline: item.week_timeline,
          percentage: item.percentage,
          isSelected: false
        }));
        // this.calculateCompletionSum()
        this.confirmSkipStage();
      });
      this.subscriptions.add(sub);
    }
  }
  calculateCompletionSum(): void {
    this.completionSum = this.stages
      .filter(stage => !stage.skipped)
      .reduce((sum, stage) => sum + Number(stage.percentage || 0), 0);
    this.completionSum = this.completionSum.toFixed(2)
  }
  confirmSkipStage() {
    const updatedStages = this.stages.map(stage => {
      const isSkipped = stage.code === 'R-POC' ? true : stage.skipped || false;

      // Create a shallow copy and modify it
      const { week_timeline, percentage, ...rest } = stage;

      return {
        ...rest,
        skipped: isSkipped,
        week_timeline: week_timeline || null,
        percentage: percentage || null,
      };
    });

    const sub = this.apiService.postAPI(`/transaction/proposals/${this.selectedProposal.id}/steps/`, updatedStages).subscribe((res: any) => {
      console.log("step submittedd")
      // this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Stages Skipped Successfully' });
      if (res.length > 0 && this.isUpdateProposal) {
        this.apiCallForTransaction();
      }
      if (res.message == 'Steps processed successfully' && !this.isUpdateProposal) {
        console.log("route submittedd called")
        // this.getStages(this.selectedScheme.id,'pass');
        this.onrouteFormSubmit()
      }
      // this.getProposal();
      const routeIndex = this.items.findIndex(i => i.label === 'Route Configuration');
      if (routeIndex !== -1) {
        // this.activeIndex = routeIndex;
      }
    });
    this.subscriptions.add(sub);

  }
  apiCallForTransaction() {
    // this.getStages(this.proposalForm.get('scheme')?.value, 'pass');
    this.getUnit()
    this.getRoleList();
    this.getUserList();
    const sub = this.apiService.getAPI(`/transaction/proposals/${this.selectedProposal.id}/steps/?skipped=False&phase_id=${this.activePhaseId}`).subscribe((res: any) => {
      this.stagesList = res
      // if (this.currentUserRoleId == '6') {
      //   // Role 6 gets full list
      //   this.stagesList = res;
      // } else {
      //   // Other roles only get the first stage
      //   this.stagesList = res.length ? [res[0]] : [];
      // }
      this.filteredStagesList = this.stagesList.filter(step => !step.skipped);
      this.routeForm.get('step')?.setValue(this.stagesList[0].id);
      this.proposal_step_id = this.stagesList[0].id; // ✅ you already have proposal_step_id here
      if (this.addMode == 'new' && !this.isUpdateProposal) {
        let unit = sessionStorage.getItem('unit_id')
        let user = sessionStorage.getItem('user_id')
        this.userID = Number(user);
        this.roleID = this.roleList[0]?.id;
        // this.routeForm.get('unit')?.patchValue(Number(unit));
        // this.routeForm.get('user')?.patchValue(Number(user));
        // this.routeForm.get('role')?.patchValue(this.roleList[0]?.id);
      }
      this.stepId = this.stagesList[0].id;
      this.onStepChange({ value: this.stepId });
      this.tryFetchingSequence();
      this.getProposalWorkflow(this.stagesList[0].id);
    });
    this.subscriptions.add(sub);

  }
  getUnit() {
    const sub = this.apiService
      .getAPI('/master/units/')
      .subscribe((res: any) => {
        this.unitList = res.data;
        console.log('this.unitList', this.unitList);

      });
    this.subscriptions.add(sub);
  }
  getRoleList() {
    const sub = this.apiService
      .getAPI('/access/user-roles/')
      .subscribe((res: any) => {
        const rolePriority = ['INT', 'REC', 'APP']; // desired order
        const resp = res.data;
        this.roleList = resp
          .filter((role) => rolePriority.includes(role.code))
          .sort(
            (a, b) =>
              rolePriority.indexOf(a.code) - rolePriority.indexOf(b.code)
          );
      });
  }
  getUserList() {
    const unit_id=sessionStorage.getItem('unit_id');
  this.apiService
      .getAPI('/account/users/?unit='+unit_id)
      .subscribe((res: any) => {
       
        this.userList = res.data;
        this.userListCopy = [...this.userList];
      });
  }
  onRoleChange(event: any) {
    this.roleID = event.value;
    this.tryFetchingSequence();
  }
  onUserChange(event: any) {
    this.userID = event.value;
    this.tryFetchingSequence();
  }
  onUnitChange(event: any) {
    let unit_id = event.value;
    this.userList = this.userListCopy.filter(
      (user) => user.unit?.id == unit_id
    );
  }
  onrouteFormSubmit() {
    const formValue = this.routeForm.value;
    const unit = Number(sessionStorage.getItem('unit_id'));
    const user = Number(sessionStorage.getItem('user_id'));

    if (!formValue.approved) {
      if (!this.isUpdateProposal) {
        this.apiService.getAPI(
          `/transaction/proposals/${this.selectedProposal.id}/steps/?skipped=False&phase_id=${this.activePhaseId}`
        ).subscribe({
          next: (res: any) => {
            const stepid = res?.[0]?.id;
            if (!stepid) {
              console.error("No step found for proposal.");
              return;
            }

            // ✅ Fetch roles and then continue
            this.apiService.getAPI('/access/user-roles/').subscribe((rolesRes: any) => {
              const rolePriority = ['INT', 'REC', 'APP'];
              this.roleList = rolesRes.data
                .filter((role: any) => rolePriority.includes(role.code))
                .sort(
                  (a: any, b: any) =>
                    rolePriority.indexOf(a.code) - rolePriority.indexOf(b.code)
                );

              if (!this.roleList.length) {
                console.error("No roles found.");
                return;
              }

              const payload = {
                status: 1,
                sequence: 0,
                proposal_step: stepid,
                user,
                unit,
                role: this.roleList[0].id, // ✅ role is now defined
                is_final_approve: formValue.approved || false
              };

              this.apiService.postAPI(`/transaction/proposal-workflow/`, payload).subscribe({
                next: (res: any) => {
                  console.log("Workflow saved:", res);
                  this.routeForm.reset();

                  if (!this.isUpdateProposal) {
                    sessionStorage.setItem('user_role_id', this.roleList[0].id);
                    sessionStorage.setItem('user_role_name', this.roleList[0].name);
                    this.messageService.add({
                      severity: 'success',
                      summary: 'Success',
                      detail: `Role has now been changed to ${this.roleList[0].name}.`
                    })
                    this.getPermissions();
                    this.addProposalVisible = false;
                    this.navigateToSchemeTransaction(this.proposalData[0], this.activePhaseId);
                  }
                },
                error: (err) => {
                  console.error("Workflow API error:", err);
                }
              });
            });
          },
          error: (err) => {
            console.error("Step API error:", err);
          }
        });

      } else {
        // Update proposal case
        const payload = {
          status: 1,
          sequence: this.routeForm.get('level')?.value,
          proposal_step: formValue.step,
          user: formValue.user,
          role: formValue.role,
          unit: formValue.unit,
          is_final_approve: formValue.approved || false
        };
        console.log("Update Payload:", payload);
        this.apiService.postAPI(`/transaction/proposal-workflow/`, payload).subscribe({
          next: (res: any) => {
            console.log("Workflow saved:", res);
            this.routeForm.reset();
            this.getProposalWorkflow(formValue.step)
          },
          error: (err) => {
            console.error("Workflow API error:", err);
          }
        });
      }
    } else {
      // Approved case
      const payload = {
        proposal_step: formValue.step,
        user: formValue.user,
        unit: formValue.unit,
        role: this.roleList?.[2]?.id,
        is_final_approve: true
      };
      console.log("Approved Payload:", payload);
      this.apiService.postAPI(`/transaction/proposal-workflow/`, payload).subscribe({
        next: (res: any) => {
          console.log("Workflow saved:", res);
          this.routeForm.reset();
          this.getProposalWorkflow(formValue.step)
        },
        error: (err) => {
          console.error("Workflow API error:", err);
        }
      });
    }
  }
  getPermissions() {
    let role_id = sessionStorage.getItem('user_role_id')
    this.apiService
      .getAPI(
        `/access/get-permissions/?role_id=${role_id}`
      )
      .subscribe((res: any) => {
        this.permissionService.setPermissions(res);
      });
  }
  setActiveIndex(index: number): void {
    this.activeIndex = index;
    // this.apiCallForTransaction()
    // Handle role-specific actions
    if (this.currentUserRoleId == '6') {
      if (index === 1) { // Route Configuration for role 6
        this.apiCallForTransaction();
      }
    } else {
      if (index === 1) { // Route Configuration for other roles
        this.apiCallForTransaction();
      }
    }
  }
  getDialogHeader(): string {
    if (this.isUpdateProposal) {
      return 'Update Challenge'
      // : `Update Proposal on ${this.activeTabName}`;
    } else {
      return 'Add New Challenge';
    }
  }
  getSchemewisePhase(scheme_id?: number) {
    this.currentsubSchemeId = scheme_id

    const sub = this.apiService.getAPI(`/master/scheme/${scheme_id}/phases/`).subscribe((res) => {
      // this.phases = res
      // ✅ Define custom order
      const order = [
        "Initiation & Approval",
        "Development Agreement",
        "Final SQR",
        "Prototype Development",
        "SSCT",
        "Induction",
        "Induction Phase",
      ];

      // ✅ Sort response according to custom order
      this.phases = res.sort(
        (a: any, b: any) => order.indexOf(a.name) - order.indexOf(b.name)
      );
      this.selectedPhaseId = this.phases[0]?.id;
      this.activePhaseId = this.phases[0]?.id
      this.getProposal();
    });
    this.subscriptions.add(sub);
  }
  navigateToSchemeTransaction(schemeName: any, phaseId: any) {
     const isShortClose = schemeName.proposal_status === 'short_close' || schemeName.proposal_status === 'approved';

    if(schemeName.scheme==7){
      this.router.navigate(['/oc-shortlisting'], {
        queryParams: { id: schemeName.id,short_close: isShortClose }
      });
    }else{
      this.router.navigate(['/idex-aditi-transaction'], {
        queryParams: { id: schemeName.id, name: schemeName.name, scheme: schemeName.scheme.id, phase: phaseId, step: schemeName.step_summary.current_step_id,short_close: isShortClose }
      });
    }

  }
  navigateToScheme(schemeName: any) {
    this.schemeService.setScheme(schemeName);
    this.router.navigate(['/proposal-dashboard'], {
      queryParams: {
        scheme: schemeName.name,
        id: schemeName.id,
        phase: this.activePhaseId,
      },
    });
  }
  next() {
    this.activeIndex += 1;
    this.getProposal();
  }
  onStepChange(event: any) {
    this.stepId = event.value;
    const sub = this.apiService
      .getAPI(`/transaction/proposal-workflow/?proposal_step_id=${event.value}`)
      .subscribe((res: any) => {
        this.RouteUserList = res.data;
        if (res.data[0]) {
          this.routeForm
            .get('approved')
            .patchValue(res.data[0]?.is_final_approve || false);
        } else {
          this.routeForm.get('approved').patchValue(false);
        }
      });
    this.subscriptions.add(sub);
    this.tryFetchingSequence();
  }
  onAllRolesSame(isSame: boolean) {
    const userId = sessionStorage.getItem('user_id');

    if (userId) {
      const matchedUser = this.userList.find((user) => user.id == userId);

      if (matchedUser) {
        if (isSame) {
          this.routeForm.patchValue({
            unit: matchedUser.unit.id,
            user: matchedUser.id,
          });
        } else {
          // Optionally reset the fields
          this.routeForm.patchValue({
            unit: null,
            user: null,
          });
        }
      } else {
        console.warn('User ID not found in users list.');
      }
    } else {
      console.warn('User ID not found in session storage.');
    }
  }
  tryFetchingSequence() {
    if (this.stepId && this.roleID && this.userID) {
      this.getSequence();
    }
  }

  getSequence() {
    const sub = this.apiService
      .getAPI(
        `/transaction/get-next-level/?proposal_step_id=${this.stepId}&role_id=${this.roleID}`
      )
      .subscribe((res: any) => {
        const sequenceValue = res.level ?? '';
        this.routeForm.get('level')?.patchValue(sequenceValue);
      });
    this.subscriptions.add(sub);
  }
  deleteUser(user: any) {
    const sub = this.apiService
      .deleteAPI(`/transaction/proposal-workflow/${user.id}/`)
      .subscribe((res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'User deleted successfully.',
        });
        this.getProposalWorkflow(user.proposal_step.id);
      });
    this.subscriptions.add(sub);
  }
  getProposalWorkflow(id: any) {
    this.RouteUserList = [];
    const sub = this.apiService
      .getAPI(`/transaction/proposal-workflow/?proposal_step_id=${id}`)
      .subscribe((res: any) => {
        // this.RouteUserList = res.data;
        const allData = res.data || [];

        // Filter only users with role.code 'INT', 'APP', or 'REC'
        this.RouteUserList = allData.filter(
          (user: any) =>
            ['INT', 'APP', 'REC'].includes(user.role.code) ||
            user.is_final_approve
        );
      });
    this.subscriptions.add(sub);
  }

  /* New design */
  showTab(tab: any) {
    this.activeTab = tab;

    if (this.activeTab == 'initiation') {
      this.gettableData();
    }
  }
  toggleSelectAll() {
    // this.filteredProposals.forEach(p => (p.selected = this.selectAll));
    this.filteredProposals.forEach((proposal) => {
      proposal.selected = this.selectAll;
    });

    if (this.selectAll) {
      this.selectedChallengeCount = [...this.filteredProposals];
    } else {
      this.selectedChallengeCount = [];
    }
  }
  onChallengeSelectChange(proposal: any) {
    if (proposal.selected) {
      // Add if not already in list
      if (!this.selectedChallengeCount.some((ch) => ch.id === proposal.id)) {
        this.selectedChallengeCount.push(proposal);
      }
    } else {
      // Remove if unchecked
      this.selectedChallengeCount = this.selectedChallengeCount.filter(
        (ch) => ch.id !== proposal.id
      );
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.currentAction == 'edit') {
        this.challengeForm?.enable();
      } else {
        this.challengeForm?.disable();
      }
      //  this.rebuildEditor();
    }, 3000);
  }
  editorReady = true;
  rebuildEditor() {
    this.editorReady = false;
    setTimeout(() => {
      this.init = this.getTinyInit(); // reapply config
      this.editorReady = true; // rebuild editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      plugins:
        'advlist anchor fullscreen insertdatetime autolink link lists image code advcode mergetags wordcount ai a11ychecker advcode advtemplate advlist advtable anchor autocorrect autosave editimage image link linkchecker lists markdown media mediaembed pageembed powerpaste searchreplace table template tinymcespellchecker typography visualblocks wordcount',
      toolbar:
        'undo redo fullscreen | styles fontsizeinput lineheight |insertdatetime  bold italic strikethrough backcolor forecolor visualblocks | align bullist numlist outdent indent | advlist  table link image media pageembed | spellcheckdialog a11ycheck code | searchreplace',
      readonly: this.currentAction === 'view',
    };
  }
  switchRole(role: string) {
    this.currentRole = role;
    this.applyFilters();
  }

  applyFilters() {
    let filtered = [...this.proposals];

    // Step 1: Category filter (from dropdown)
    if (this.filters.category) {
      filtered = filtered.filter((p) => p.category === this.filters.category);
    }

    // Step 2: Role filter (restrict based on role)
    // if (this.currentRole === 'doi') {
    //   filtered = filtered.filter(p => ['To Move', 'To Float'].includes(p.category));
    // } else if (this.currentRole === 'tdac') {
    //   filtered = filtered.filter(p => p.category === 'To Fight');
    // }

    // Step 3: Priority filter
    if (this.filters.priority) {
      filtered = filtered.filter((p) => p.priority === this.filters.priority);
    }
    if (this.filters.valuation) {
      filtered = filtered.filter((p) => p.valuation === this.filters.valuation);
    }
    // Step 4: Status filter (if needed)
    if (this.filters.status) {
      // filtered = filtered.filter(p => p.status === this.filters.status);
    }

    this.filteredProposals = filtered;
    this.updateStats();
  }

  updateStats() {
    this.stats.total = this.filteredProposals.length;
    // this.stats.pending = this.filteredProposals.filter(p => p.status === 'pending').length;
    // this.stats.screening = this.filteredProposals.filter(p => p.status === 'screening').length;
    // this.stats.approved = this.filteredProposals.filter(p => p.status === 'approved').length;
  }

  updateCategory(id: any, category: string) {
    const p = this.proposals.find((x) => x.id == id);
    if (p) p.category = category;
    this.applyFilters(); // optional: refresh view/stats if you rely on filteredProposals
  }

  viewDetailsN(proposal: Proposal, mode: 'view') {
    this.selectedProposal = proposal;
    this.detailsModalOpen = true;
    this.currentAction = mode;
    this.isEditMode = false;
    this.rebuildEditor();
    this.challengeForm.disable();
    this.challengeForm.patchValue({
      organisation: proposal.organisation,
      category: proposal.category,
      releaseDate: proposal.release_date,
      approvedBy: proposal.approved_by,
      coordinatingAgency: proposal.coordinated_agency,
      technologyDomain: proposal.technology_domain,

      challengeTitle: proposal.title,
      nodalOfficer: proposal.nodal_officer,
      problemStatement: proposal.problem_statement,
      challengeBrief: proposal.challenge_brief,
      prototypeDevelopment: proposal.prototype_development,
      requirement: proposal.requirement,
      ipValue: proposal.ip_value,
      functionalAdvantages: proposal.functional_advantages,
      domestic: proposal.domestic,
      substitution: proposal.substitution,
      preliminaryScope: proposal.preliminary_scope,
      competitiveSolution: proposal.competitive_solution,
      potentialMarket: proposal.potential_market,
      riskAssessment: proposal.risk_assessment,
      mpoQty: proposal.mpo_qty,
    });
  }
  // savetableData(proposal: Proposal) {
  //   this.challengeForm.reset();
  //   this.selectedProposal = proposal;
  //   this.challengeForm.patchValue({
  //     organisation: proposal.organisation,
  //     category: proposal.category,
  //     priority: proposal.priority,
  //     releaseDate: proposal.release_date,
  //     approvedBy: proposal.approved_by,
  //     coordinatingAgency: proposal.coordinated_agency,
  //     technologyDomain: proposal.technology_domain,

  //     // valuation:proposal.valuation, // fields for DIO
  //     challenge_status: proposal.challenge_status,

  //     challengeTitle: proposal.title,
  //     nodalOfficer: proposal.nodal_officer,
  //     problemStatement: proposal.problem_statement,
  //     challengeBrief: proposal.challenge_brief,
  //     prototypeDevelopment: proposal.prototype_development,
  //     requirement: proposal.requirement,
  //     ipValue: proposal.ip_value,
  //     functionalAdvantages: proposal.functional_advantages,
  //     domestic: proposal.domestic,
  //     substitution: proposal.substitution,
  //     preliminaryScope: proposal.preliminary_scope,
  //     competitiveSolution: proposal.competitive_solution,
  //     potentialMarket: proposal.potential_market,
  //     riskAssessment: proposal.risk_assessment,
  //     mpoQty: proposal.mpo_qty,
  //   });
  //   this.onSubmit();
  // }

  closeDetailsModal() {
    this.detailsModalOpen = false;
    this.selectedProposal = null;
  }

  editProposal(proposal: Proposal, mode: 'edit') {
    this.currentAction = mode;
    this.rebuildEditor();
    this.isEditMode = true;
    this.challengeForm.enable();

    this.selectedProposal = { ...proposal };
    this.challengeForm.reset();
    console.log(proposal);
    this.challengeForm.patchValue({
      organisation: proposal.organisation,
      category: proposal.category,
      releaseDate: proposal.release_date,
      approvedBy: proposal.approved_by,
      coordinatingAgency: proposal.coordinated_agency,
      technologyDomain: proposal.technology_domain,
      challenge_status: proposal.challenge_status,
      ip_status: proposal.ip_status,

      challengeTitle: proposal.title,
      nodalOfficer: proposal.nodal_officer,
      problemStatement: proposal.problem_statement,
      challengeBrief: proposal.challenge_brief,
      prototypeDevelopment: proposal.prototype_development,
      requirement: proposal.requirement,
      ipValue: proposal.ip_value,
      functionalAdvantages: proposal.functional_advantages,
      domestic: proposal.domestic,
      substitution: proposal.substitution,
      preliminaryScope: proposal.preliminary_scope,
      competitiveSolution: proposal.competitive_solution,
      potentialMarket: proposal.potential_market,
      riskAssessment: proposal.risk_assessment,
      mpoQty: proposal.mpo_qty,
    });
    this.detailsModalOpen = true;
  }
  gettableData() {
    this.apiService
      .getAPI(`/idex/dashboard/challenge/list/?role_id=${this.userID}`)
      .subscribe({
        next: (res: any[]) => {
          this.proposals = res;
          this.filteredProposals = [...this.proposals];
        },
      });
  }
  onFileSelect(event: any, type: string) {
    const files: File[] = event.files;

    if (type === 'draftSotr') {
      this.draftSotrFile = files[0]; // Only one file expected
    } else if (type === 'supportingDocs') {
      // this.supportingDocsFiles = [...this.supportingDocsFiles, ...files];
      this.supportingDocsFiles = files[0];
    }
  }

  onUploadDraftSotr(event: any) {
    const file: File = event.files[0];
    if (file) {
      this.draftSotrFile = file;
      this.messageService.add({
        severity: 'success',
        summary: 'File attached successfully',
        detail: file.name,
      });
    }
  }

  onUploadSupportingDocs(event: any) {
    // const files: File[] = event.files;
    const file: File = event.files[0];
    if (file) {
      this.supportingDocsFiles = file;
    }
    // this.supportingDocsFiles = [...this.supportingDocsFiles, ...files];
    this.messageService.add({
      severity: 'success',
      summary: 'Supporting Documents Uploaded',
      detail: ` files uploaded`,
    });
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }
  onSubmitch() {
    let formData = new FormData();
    console.log(this.challengeForm.value);

    formData.append(
      'organisation',
      this.challengeForm.get('organisation').value
    );
    formData.append('category', this.challengeForm.get('category')?.value);
    formData.append('priority', this.challengeForm.get('priority')?.value);
    formData.append(
      'ip_status',
      this.challengeForm.get('valuation')?.value || ''
    );
    formData.append(
      'challenge_status',
      this.challengeForm.get('challenge_status')?.value || ''
    );
    formData.append(
      'release_date',
      this.challengeForm.get('releaseDate').value
    );
    if (this.challengeForm.get('approvedBy').value != null) {
      formData.append(
        'approved_by',
        this.challengeForm.get('approvedBy').value
      );
    }
    formData.append(
      'coordinated_agency',
      this.challengeForm.get('coordinatingAgency').value
    );
    formData.append(
      'technology_domain',
      this.challengeForm.get('technologyDomain').value
    );

    formData.append('title', this.challengeForm.get('challengeTitle').value);
    formData.append(
      'nodal_officer',
      this.challengeForm.get('nodalOfficer').value
    );
    formData.append(
      'problem_statement',
      this.challengeForm.get('problemStatement').value
    );
    formData.append(
      'challenge_brief',
      this.challengeForm.get('challengeBrief').value
    );
    formData.append(
      'prototype_development',
      this.challengeForm.get('prototypeDevelopment').value
    );
    formData.append('requirement', this.challengeForm.get('requirement').value);
    formData.append('ip_value', this.challengeForm.get('ipValue').value);
    formData.append(
      'functional_advantages',
      this.challengeForm.get('functionalAdvantages').value
    );
    formData.append('domestic', this.challengeForm.get('domestic').value);
    formData.append(
      'substitution',
      this.challengeForm.get('substitution').value
    );
    formData.append(
      'preliminary_scope',
      this.challengeForm.get('preliminaryScope').value
    );
    formData.append(
      'competitive_solution',
      this.challengeForm.get('competitiveSolution').value
    );
    formData.append(
      'potential_market',
      this.challengeForm.get('potentialMarket').value
    );
    formData.append(
      'risk_assessment',
      this.challengeForm.get('riskAssessment').value
    );
    formData.append('mpo_qty', this.challengeForm.get('mpoQty').value);

    if (this.draftSotrFile) {
      formData.append('pds', this.draftSotrFile);
    }

    if (this.supportingDocsFiles) {
      // this.supportingDocsFiles.forEach(file => {
      formData.append('pru', this.supportingDocsFiles); // Change key name if needed
      // });
    }
    console.log(formData, this.selectedProposal);
    let url = `/idex/challenges/${this.selectedProposal.id}/`;

    const sub = this.apiService.putAPI(url, formData).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Challenge Updated successfully',
        });
        this.gettableData();
        this.fileUpload.clear();
        this.draftSotrUpload.clear();
      },
      error: (err) => { },
    });
    this.subscriptions.add(sub);
  }
  routeModal: boolean = false;
  openRouteModal() {
    // alert('Open route configuration modal here.');
    this.routeModal = true;
    this.selectedChallenges = this.proposals.filter((p) => p.selected);
    this.getRoleList();
    // this.getUserList();
    // this.getUnit();
    if (this.selectedChallenges.length > 0) {
      this.routeModal = true;
    }
  }

  submitIRA() {
    let role_id = sessionStorage.getItem('user_role_id');
    const payload = this.selectedChallenges.map((challenge, index) => ({
      proposal_step: challenge.current_proposal_step,
      role_id: Number(role_id),
      is_approved: true,
      remark: this.IRAremarks,
    }));
    console.log('ira', payload);
    this.IRAremarks = '';
    const sub = this.apiService
      .postAPI(`/idex/bulk/proposal-ira-action/`, payload)
      .subscribe((res: any) => {
        this.isEditable = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'Proposal added successfully',
        });
      });
    this.subscriptions.add(sub);
  }
  updatelaunchStatus(id: any, priority: string) { }

  selectedPhaseProposals: any[] = [];

  onPhaseChange(index: number) {
    this.activeTabIndex = index;
    this.selectedPhaseProposals = this.getProposalsByPhase(this.phases[index].id);
  }

  getProposalsByPhase(phaseId: number) {
    return this.proposalData.filter(p => p.phase_id == phaseId);
  }
  isSectionOpen = {
    draftProposals:false,
    basicInfo: true,
    equipment: true,
    quantity: true,
    cost: true,
    detailed: true,
    uploads: true
  };

  // new code for proposals list design 
  toggleSection(section: keyof typeof this.isSectionOpen): void {
    this.isSectionOpen[section] = !this.isSectionOpen[section];
  }

  // Filter proposals by status tab
  filterProposalsByStatus() {
    const activeTab = this.proposalStatusTabs[this.activeStatusTabIndex];

    // Special handling for "New Proposal" tab (form)
    if (activeTab.status === 'form') {
      this.proposalData = []; // Empty array for form tab
      return;
    }

    let filteredData = this.filteredRecentProposals.filter(
      (proposal) => proposal.proposal_status === activeTab.status
    );

    // Apply search filter if there's a search query
    if (this.searchProposalQuery) {
      filteredData = filteredData.filter(
        (proposal) =>
          proposal.name.toLowerCase().includes(this.searchProposalQuery) ||
          proposal.description.toLowerCase().includes(this.searchProposalQuery) ||
          proposal.scheme.name?.toLowerCase().includes(this.searchProposalQuery)
      );
    }

    this.proposalData = filteredData;
  }
  // Handle proposal status tab change
  onProposalStatusTabChange(tab: any) {
    const tabIndex = tab.tab;
    this.activeStatusTabIndex = tab;
    if (tabIndex === 0) {
      this.getDraftProposals()
    }if (tabIndex === 2 && this.selectedScheme.id == 7) {
      this.getOCversionList()
      this.tableColumns=this.ocTableHeader
    } else {
      this.tableColumns=this.proposalTableHeader
      this.getProposal(tab, 1)
    }
    
  }
  ocTableHeader: any[] = [
    // { field: 'actions', header: 'Actions', filterType: 'text',filter:false },
    { field: 'name', header: 'Version', filterType: 'text',filter:true },
    { field: 'start_date', header: 'Start Date', filterType: 'text',filter:true },
    { field: 'end_date', header: 'End Date', filterType: 'text',filter:true },
  ]
    getOCversionList() {
      this.apiService.getAPI('/master/oc/proposal/').subscribe((res: any) => {
        this.proposalData=res.data
      })
    }
  totalCount = 10
  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'];
    if (allowedKeys.includes(event.key)) return;

    const isNumber = /^[0-9]$/.test(event.key);
    if (!isNumber) {
      event.preventDefault();
    }
  }

  draftProposals: any[] = [];
  getDraftProposals() {
    this.apiService.getAPI('/idex/save-draft/proposal/').subscribe((res: any) => {
      // this.draftProposals = res;
      this.draftProposals = (res || []).map((draft: any) => ({
          ...draft,
          nomenclature: draft.nomenclature || draft.proposal_name || draft.proposal?.name || draft.name || '-'
        }));
      console.log('>>>>>get list save draft', this.draftProposals);
    });
  }
  // populate proposals
  populateDraftProposal(draft: any) {
    console.log('✅ Editing draft proposal:', draft);
    this.selectedDraftProposal = draft;
    
    // Prepare API calls for lists that need to be loaded
    const apiCalls: any[] = [];
    
    // Load schemes if not already loaded
    if (this.schemes.length === 0) {
      const url = this.currentSchemeId ? `/master/scheme/sub/details/?id=${this.currentSchemeId}` : `/master/scheme/sub/details/`;
      apiCalls.push(
        this.apiService.getAPI(url).pipe(
          tap((res: any) => {
            this.schemes = res[0]?.sub_scheme || [];
          })
        )
      );
    } else {
      apiCalls.push(of(null));
    }
    
    // Load unitList if not already loaded
    if (this.unitList.length === 0) {
      const unit_id=sessionStorage.getItem('unit_id');
      apiCalls.push(
        this.apiService.getAPI('/master/units/?unit='+unit_id).pipe(
          tap((res: any) => {
            this.unitList = res.data || [];
          })
        )
      );
    } else {
      apiCalls.push(of(null));
    }
    
    // Load userList if not already loaded
    if (this.userList.length === 0) {
      apiCalls.push(
        this.apiService.getAPI('/account/users/').pipe(
          tap((res: any) => {
            this.userList = res.data || [];
            this.userListCopy = [...this.userList];
          })
        )
      );
    } else {
      apiCalls.push(of(null));
    }
    
    // Wait for all API calls to complete, then patch the form
    forkJoin(apiCalls).subscribe({
      next: () => {
        this.patchDraftForm(draft);
      },
      error: (err) => {
        console.error('Error loading lists:', err);
        // Still try to patch the form even if some calls failed
        this.patchDraftForm(draft);
      }
    });
  }
  
  private patchDraftForm(draft: any) {
    // Handle coordinated_agency - it might be an ID or null
    let coordinatedAgencyValue = null;
    if (draft.coordinated_agency) {
      if (typeof draft.coordinated_agency === 'number' || !isNaN(Number(draft.coordinated_agency))) {
        // It's already an ID
        coordinatedAgencyValue = Number(draft.coordinated_agency);
      } else if (typeof draft.coordinated_agency === 'string') {
        // It's a name string, find the matching ID
        const unit = this.unitList.find(u => u.name === draft.coordinated_agency);
        coordinatedAgencyValue = unit ? unit.id : null;
      }
    } else if (draft.coordinated_agency_id) {
      coordinatedAgencyValue = Number(draft.coordinated_agency_id);
    }
    
    // Handle nodal_officer - it might be an ID or null
    let nodalOfficerValue = null;
    if (draft.nodal_officer) {
      if (typeof draft.nodal_officer === 'number' || !isNaN(Number(draft.nodal_officer))) {
        // It's already an ID
        nodalOfficerValue = Number(draft.nodal_officer);
      } else if (typeof draft.nodal_officer === 'string') {
        // It's a name string, find the matching ID
        const user = this.userList.find(u => {
          const fullName = `${u.first_name}${u.last_name ? ' ' + u.last_name : ''}`;
          return fullName === draft.nodal_officer || u.first_name === draft.nodal_officer;
        });
        nodalOfficerValue = user ? user.id : null;
      }
    } else if (draft.nodal_officer_id) {
      nodalOfficerValue = Number(draft.nodal_officer_id);
    }
    
    // Handle scheme - use scheme_id for the dropdown
    let schemeValue = draft.scheme_id || parseInt(this.currentSchemeId);
    
    // Handle category - ensure it matches the dropdown options
    let categoryValue = draft.category || '';
    
    // Patch the form with all values
    this.proposalForm.patchValue({
      id: draft.id,
      proposal_id: draft.proposal_id,
      name: draft.proposal_name || draft.title || '',
      challenge_brief: draft.challenge_brief || '',
      scheme_name: schemeValue, // Use scheme_id for the dropdown
      coordinated_agency: coordinatedAgencyValue,
      nodal_officer: nodalOfficerValue,
      organisation: draft.organisation || '',
      category: categoryValue,
      release_date: draft.release_date ? draft.release_date.split('T')[0] : '',
      technology_domain: draft.technology_domain || '',
      problem_statement: draft.problem_statement || '',
      status: draft.status || 1,
      prototype_development: draft.prototype_development || '',
    });
    
    // Mark form as dirty to enable save/submit buttons
    this.proposalForm.markAsDirty();
    
    this.stepId = draft.proposal_step;
    this.needId = draft.need_id || draft.id;
    
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    this.messageService.add({
      severity: 'info',
      summary: 'Draft Loaded',
      detail: `Editing draft "${draft.proposal_name || draft.title}".`
    });
    
    
  }
  // for clear 
  clear(table: any, searchInput: HTMLInputElement): void {
    searchInput.value = '';
    this.searchProposalQuery = '';
    this.lazy = true;
    this.getProposal(this.activeStatusTabIndex)
  }
  onPageChange(event) {
    const rows = event.rows;
    const first = event.first;
    const page = first / rows + 1;
    this.getProposal(this.activeStatusTabIndex,page);
  }
  onActiveIndexChange(event: any) {
    this.activeIndex = event;
  }
  searchQuery: string = '';
  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'approved':
        return 'bg-success';
      case 'pending':
        return 'bg-warning text-dark';
      case 'short_closed':
        return 'bg-secondary';
      case 'rejected':
        return 'bg-danger';
      default:
        return 'bg-info';
    }
  }
  getFieldValue(obj: any, fieldPath: string): any {
    if (!obj || !fieldPath) {
      return null;
    }
    try {
      return fieldPath.split('.').reduce((acc, part) => {
        if (acc && typeof acc === 'object' && part in acc) {
          return acc[part];
        }
        return undefined;
      }, obj);
    } catch {
      return undefined;
    }
  }
  // In your component.ts file
  shareType: string;
  permissionType: string;
  selectedUser: any; // For single selection (edit)
  selectedUsers: any[] = []; // For multiple selection (view/comment)
  selectedUnit: any; // For single selection (edit)
  selectedUnits: any[] = []; // For multiple selection (view/comment)
  displayDialogN = false;
  selectedUserN: any;
  internalComment: string
  externalComment: string
  // 🔹 Open the dialog
  openDialog() {
    this.displayDialogN = true;
    this.resetSharingForm();
    this.getUserList(); // load internal users
    this.getUnit();     // load external units
  }
  // 🔹 Reset all sharing form fields
  resetSharingForm() {
    this.shareType = null;
    this.permissionType = null;
    this.selectedUser = null;
    this.selectedUsers = [];
    this.selectedUnit = null;
    this.selectedUnits = [];
    this.internalComment = '';
    this.externalComment = '';
  }
  // Add validation method
  isFormValid(): boolean {
    if (!this.shareType || !this.permissionType) return false;

    if (this.shareType === 'internal') {
      if (this.permissionType === 'edit') {
        return !!this.selectedUser;
      } else {
        return this.selectedUsers && this.selectedUsers.length > 0;
      }
    } else {
      if (this.permissionType === 'edit') {
        return !!this.selectedUnit;
      } else {
        return this.selectedUnits && this.selectedUnits.length > 0;
      }
    }
  }

  isLoading: boolean = false;
  onNeedformSubmit(event: any) {
    this.isLoading = true;
  const routePayload: any = {
    remark: event.internalComment,
    is_external: event.shareType === 'external',
  };
  if (event.shareType === 'external') {
    routePayload.unit_id = event.selectedUnit?.id;
    routePayload.command = event.selectedCommand;

  } else {
    routePayload.user = event.selectedUser?.id;
  }
    this.proposalPayload.route_conf = routePayload;
      const fd = new FormData();
    fd.append('data', new Blob([JSON.stringify(this.proposalPayload)], { type: 'application/json' }));
    const meta: any[] = [];
    (this.selectedDmsFiles || []).forEach((it: any, i: number) => {
      if (!it?.file) return;
      const name = it.name || `file_${i + 1}`;
      fd.append('files', it.file, name);
      meta.push({ id: it?.id, name, description: it.description || '', type_document: it.type || it.file?.type || '', date: it.date || '' });
    });
    fd.append('files_meta', new Blob([JSON.stringify(meta)], { type: 'application/json' }));


    // ✅ Step 4: Call the API
    this.apiService.postAPI('/idex/initiated/proposal/', fd).subscribe(res=>{
          this.messageService.add({  severity: 'success',  summary: 'Success',    detail: res.message || 'Proposal shared successfully.'      });
          this.displayDialogN = false;
          this.onProposalStatusTabChange(this.proposalStatusTabs[1])
          this.resetSharingForm(); 
          this.idexFromComponent.refreshForm();
          this.isLoading = false;
      });
  }
  // this is use for upload document table
  onDocumentUpload(data: any) {
    this.selectedDmsFiles.push(data); 
  }
  proposalPayload: any;
  submitProposal(payload: any) {
    this.proposalPayload = payload.payload;
    this.selectedDmsFiles = payload?.selectedDmsFiles;
    this.openDialog();
  }


  // submitOcFrom(){
  //   this.isLoading = true;
  //   const payload: any = {
  //     is_final_approve: false,
  //     route_type: this.shareType
  //   };
  
  //   if (this.shareType === 'internal') {
  //     if (this.permissionType === 'edit') {
  //       payload.user = this.selectedUser?.id;
  //       payload.unit = this.selectedUser?.unit?.id || null;
  //       delete payload.users;
  //     } else {
  //       payload.user = this.selectedUsers?.map(user => user.id) || [];
  //       // Pass unit as a single pk value (not array) for view and comment
  //       payload.unit = this.selectedUsers?.[0]?.unit?.id || null;
  //       delete payload.users;
  //     }
  //     payload.flag = 1;
  //     payload.permission_type = this.permissionType;
  //     payload.remark = this.internalComment;
  //   }
  
  //   if (this.shareType === 'external') {
  //     if (this.permissionType === 'edit') {
  //       payload.unit = this.selectedUnit?.id;
  //     } else {
  //       payload.unit = this.selectedUnits?.map(unit => unit.id) || [];
  //     }
  //     payload.permission_type = this.permissionType;
  //     payload.remark = this.externalComment;
  //   }

  //   if (!this.isFormValid()) {
  //     this.messageService.add({
  //       severity: 'error',
  //       summary: 'Error',
  //       detail: 'Please fill all required fields and make valid selections.'
  //     });
  //     return;
  //   }
  //   this.proposalPayload.route_conf = payload;
  //   console.log(this.proposalPayload);
  //   this.apiService.postAPI('/idex/oc/initiated/proposal/', this.proposalPayload).subscribe((res: any) => {
  //     this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.message || 'Proposal shared successfully.' });
  //     this.displayDialogN = false;
  //     this.resetSharingForm(); 
  //     this.ocProposalUploadComponent.refreshForm();
  //     this.isLoading = false;
  //   });
  // }
  showCustomInputPopup=false
  customPopupInput={date:null, version:null};
  onCustomInputSubmit() {
    this.showCustomInputPopup = false;
    this.selectedProposals.forEach(proposal=>{
      this.apiService.putAPI(`/idex/proposal/challenges/${proposal.id}/`, {launch_version: this.customPopupInput.version, launch_date: this.customPopupInput.date,  challenge_status: "Launch"}).subscribe(res=>{
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Proposal updated successfully.' });
        this.onProposalStatusTabChange(this.proposalStatusTabs[2]);
        this.customPopupInput={date:null,version:null}
      })
    })
  }
}
export interface Proposal {
  [x: string]: any;
  id: number;
  isInitiator: boolean;
  isRecommender: boolean;
  isApprover: boolean;
  proposal_name: string;
  code: string;
  status: number;
  organisation: string;
  category: string;
  releaseDate: string | null;
  coordinated_agency: string;
  technology_domain: string;
  title: string;
  nodal_officer: string;
  problem_statement: string;
  challenge_brief: string;
  prototype_development: string;
  requirement: string;
  functional_advantages: string;
  domestic: string;
  substitution: string;
  preliminary_scope: string;
  competitive_solution: string;
  potential_market: string;
  risk_assessment: string;
  mpo_qty: string;
  ip_value: string | null;
  pds: string | null;
  pru: string | null;
  priority: string | null;
  proposalStep: number;
  created_on: string;
  modifiedOn: string;
  createdBy: number;
  modifiedBy: number;
  approved_by: number | null;
  selected?: any;
  release_date?: string;
  proposal_step?: any;
  next_proposal_step_id?: any;
  valuation?: string;
  launchStatus?: string;
  challenge_status?: string;
  ip_status?: string;
  current_proposal_step?: number;
}

interface Equipment {
  id: number;
  name: string;
}
interface System {
  id: number;
  name: string;
}